export default __webpack_public_path__ + "static/media/user.4534a622.svg";